import React from "react";

const styles = `
.t26-loader {
  position: fixed; inset: 0;
  background: color-mix(in oklab, var(--bg) 80%, transparent);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
}
.t26-loader__spinner {
  width: 36px; height: 36px;
  border-radius: 50%;
  border: 3px solid color-mix(in oklab, var(--primary) 20%, transparent);
  border-top-color: var(--primary);
  animation: t26-spin .8s linear infinite;
}
@keyframes t26-spin { to { transform: rotate(360deg); } }
`;

export default function Loader() {
    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <div className="t26-loader" role="status" aria-live="polite">
                <div className="t26-loader__spinner" />
            </div>
        </>
    );
}
